import _ from 'lodash';
import { HttpClient } from 'api/helpers/HttpClient';

export const getSearchPredictive = params => {
  const { url, hasClaroAdActive, ...restParams } = params;
  const apiCall = new HttpClient({ hasClaroAdActive: hasClaroAdActive });
  return apiCall
    .get(url, {
      ...restParams,
    })
    .then(res =>res)
    .catch(error => {
      throw error
    });
};
